import type { RouteAccess } from '@perceptio-llm/features/navigation';

export interface AccessEvaluationContext {
  can: (capability: string) => boolean;
  roles: readonly string[];
  predicates: Readonly<Record<string, () => boolean>>;
}

export function satisfiesAccessRule(
  rule: RouteAccess | undefined,
  context: AccessEvaluationContext,
): boolean {
  if (!rule) return true;
  if (rule.all && !rule.all.every(context.can)) return false;
  if (rule.any && !rule.any.some(context.can)) return false;
  if (rule.none && rule.none.some(context.can)) return false;
  if (rule.roles && !rule.roles.some((role) => context.roles.includes(role))) {
    return false;
  }
  if (rule.predicate) {
    const predicate = context.predicates[rule.predicate];
    if (!predicate)
      throw new Error(`Unknown access predicate: ${rule.predicate}`);
    if (!predicate()) return false;
  }
  return true;
}

export function satisfiesAllAccessRules(
  rules: readonly (RouteAccess | undefined)[],
  context: AccessEvaluationContext,
): boolean {
  return rules.every((rule) => satisfiesAccessRule(rule, context));
}
